import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { getFontSize, getFontWeight } from "../../../../components/CustomText";
import CustomBoard from "../../../../components/CustomBoard";
import Color from "../../../../../utils/Color";
import "fontsource-muli";
import CustomOTP from "../../../../components/CustomOTP";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as selector from "../../../../../common/selectors";
import * as forgotUserIdSelector from "../../../../../common/selectors/auth";
import * as forgotUserIdAction from "../../../../../common/actions/auth";
import * as registrationSelector from "../../../../../common/selectors/registration";
import * as registrationAction from "../../../../../common/actions/registration";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import AuthManager from "../../../../../utils/AuthManager";
import CustomToast from "../../../../components/CustomToast";
import * as authAction from "../../../../../common/actions/auth";

class RegistrationOtp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: "",
      height: 0,
      resendOtp: false,
      verifyOTPAction: false,
      customToastStatus: false,
      localNric: "",
      localOtpRef: "",
      localClientMobile: "",
      localClientMobileLast4Digits: "",
      localCountryCode: "",
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    const { registrationOTPVerifyData } = this.props;

  
    await AuthManager.retrieveNric().then((value) => {
      if (value) {
      
        this.setState({ localNric: value });
       
      }
    });
    await AuthManager.retrieveOtpReference().then((value) => {
      if (value) {
       
        this.setState({ localOtpRef: value });
       
      }
    });
    await AuthManager.retrieveClientMobileNo().then((value) => {
      if (value) {
        
        var a = value.substring(value.length - 4);
        this.setState({ localClientMobile: value });
        this.setState({ localClientMobileLast4Digits: a });
       
      }
    });
    await AuthManager.retrieveMobileCountryCode().then((value) => {
      if (value) {
       
        this.setState({ localCountryCode: value });
       
      }
    });
    //const { nric } = this.props.location.state;
   
  }

  componentDidUpdate() {
    const {
      registrationOTPVerifyStatus,
      registrationOTPVerifyLoading,
      registrationOTPVerifyData,
    } = this.props;
    //const { nric } = this.props.location.state;

    if (
      registrationOTPVerifyStatus === true &&
      registrationOTPVerifyLoading === false &&
      registrationOTPVerifyData !== null &&
      this.state.verifyOTPAction === true
    ) {
      const regData = registrationSelector.registrationOTPVerifyDataData(
        registrationOTPVerifyData
      );
      const regSuccess = registrationSelector.registrationOTPVerifyDataSuccess(
        registrationOTPVerifyData
      );
      const dob = registrationSelector.registrationOTPVerifyDOB(
        regData
      );
      const email = registrationSelector.registrationOTPVerifyEmail(
        regData
      );
      const token = registrationSelector.registrationOTPVerifyToken(
        regData
      );
      const sessionId = registrationSelector.registrationOTPVerifySessionId(
        regData
      );
      const name = registrationSelector.registrationOTPVerifyName(
        regData
      );
      const isEditable = registrationSelector.registrationOTPVerifyIsEditable(
        regData
      );
      const verifyMsg = registrationSelector.registrationOTPVerifyMessage(
        regData
      );
      const sessionExpiryWarning = registrationSelector.registrationOTPVerifyExpiryWarning(
        regData
      );
      const sessionExpiryEnd = registrationSelector.registrationOTPVerifyExpiryEnd(
        regData
      );
      const IsDirectClient = registrationSelector.registrationOTPVerifyDirectClient(
        regData
      );
      //this.props.getAuthTokenRequest(this.state.localNric);
    
      if (regSuccess !== false) {
        this.setState({ verifyOTPAction: false });
        AuthManager.setRegistrationNRIC(this.state.localNric);
        AuthManager.setRegistrationEmail(email);
        AuthManager.setRegistrationDOB(dob);
        AuthManager.setToken(token);
        AuthManager.setName(name);
        AuthManager.setIsEditableNameorDOB(isEditable);
        //this.props.getAuthTokenRequest(nric);
        AuthManager.setIsMasterAccount("false");
        AuthManager.setSessionID(sessionId);
        AuthManager.setExpiryWarning(sessionExpiryWarning);
        AuthManager.setExpiryEnd(sessionExpiryEnd);
        AuthManager.setDirectClient(IsDirectClient);
        window.location.href = process.env.REACT_APP_TIQ_BASE_URL;
      } else {
        //console.log("regSuccess",regSuccess)
        this.setState({ customToastStatus: true });
        this.setState({
          toastMessage: "You have entered an invalid OTP. Please try again.",
        });
        this.setState({ verifyOTPAction: false });
      }
    } else if (
      registrationOTPVerifyStatus === false &&
      registrationOTPVerifyLoading === false &&
      registrationOTPVerifyData === null &&
      this.state.verifyOTPAction === true
    ) {
      this.setState({ customToastStatus: true });
      this.setState({
        toastMessage:
          "Your OTP code doesn't match the given one. Please try again or request for another OTP.",
      });
      this.setState({ verifyOTPAction: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight });
  }

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatus: false });
  };

  onChangeOTP = (event) => {
    this.setState({ otp: event.target.value });
  };

  // onClickResend = () => { 
  //   //const { nric } = this.props.location.state;
  //   const { localClientMobile, localCountryCode } = this.state;
  //   this.setState({ resendOtp: true });
  //   const { registrationOtpResend, promptMobilePhoneInput } = this.props;
  //   if (localClientMobile && localCountryCode !== "") {
  //     promptMobilePhoneInput(
  //       this.state.localNric,
  //       localClientMobile,
  //       localCountryCode
  //     );
  //   } else {
  //     registrationOtpResend(this.state.localNric);
  //   }
  // };

  onClickResend = async () => {
    const { localClientMobile, localCountryCode, localNric } = this.state;
    const { registrationOtpResend, promptMobilePhoneInput } = this.props;
  
    try {
      // Call reCAPTCHA API to get the token
      const recaptchaToken = await window.grecaptcha.execute(
        "6Lce7OMZAAAAALxOm9WwIETw1EL9UB73SDe4g0Tx",
        { action: "WEB_REGISTRATION_OTP" }
      );
  
      if (!recaptchaToken) {
        this.setState({
          customToastStatus: true,
          toastMessage: "Unable to verify reCAPTCHA. Please try again.",
        });
        return;
      }
  
      // Update resendOtp state
      this.setState({ resendOtp: true });
  
      // Decide which function to call based on the availability of localClientMobile and localCountryCode
      if (localClientMobile && localCountryCode !== "") {
        promptMobilePhoneInput(localNric, localClientMobile, localCountryCode, recaptchaToken);
      } else {
        registrationOtpResend(localNric, recaptchaToken);
      }
    } catch (error) {
      this.setState({
        customToastStatus: true,
        toastMessage: "Error during reCAPTCHA verification. Please try again.",
      });
    }
  };
  

  onClickBack = () => {
    //window.history.back();
    const { history } = this.props;
    history.push("/Registration");
  };

  handleKeypress = (event) => {
    //it triggers by pressing the enter key
    if (event.keyCode === 13) {
      this.onClickVerify();
    }
  };

  onClickVerify = () => {
    const { history, location } = this.props;
    const { registrationOtpVerify } = this.props;
    //const { nric, otpReference } = this.props.location.state;
    const { resendOtpData,promptMobilePhoneInputData,registrationOtpResendData } = this.props;
    const resendOtpReference = registrationSelector.registrationOtpResendDataData(
      registrationOtpResendData
    );
    const mobilePhoneInputOtpRef = registrationSelector.promptMobilePhoneInputDataOtpReference(
      promptMobilePhoneInputData
    );
    
    if (this.state.localCountryCode !== "") {
      if (this.state.resendOtp === true) {
        registrationOtpVerify(
          this.state.localNric,
          mobilePhoneInputOtpRef,
          this.state.otp,
          this.state.localClientMobile,
          this.state.localCountryCode
        );
        
      } else {
        registrationOtpVerify(
          this.state.localNric,
          this.state.localOtpRef,
          this.state.otp,
          this.state.localClientMobile,
          this.state.localCountryCode
        );
      }
    } else {
      if (this.state.resendOtp === true) {
        registrationOtpVerify(
          this.state.localNric,
          resendOtpReference,
          this.state.otp,
          "",
          ""
        );
        
      } else {
        registrationOtpVerify(
          this.state.localNric,
          this.state.localOtpRef,
          this.state.otp,
          "",
          ""
        );
      }
    }

    this.setState({ verifyOTPAction: true });
    // const { nextScene } = location.state;
    // history.push(nextScene);
  };

  renderChildren = () => {
    const { otp } = this.state;
    return (
      <div>
        <CustomOTP
          otp={otp}
          onChangeOTP={this.onChangeOTP}
          onClickResend={this.onClickResend}
          onClickVerify={this.onClickVerify}
          MobilePhoneLabel={this.state.localClientMobileLast4Digits}
          onClickBack={this.onClickBack}
          handleKeypress={this.handleKeypress}
          forgetPasswordAction={false}
        />
      </div>
    );
  };

  render() {
    const {
      classes,
      resendOtpLoading,
      registrationOTPVerifyLoading,
      getAuthTokenLoading,
      promptMobilePhoneInputLoading,
      registrationOtpResendLoading,
    } = this.props;
    const { height } = this.state;
    return (
      <div className={classes.root}>
        <CustomBoard children={this.renderChildren()} height={height} />
        <CustomToast
          open={this.state.customToastStatus}
          handleCloseCustomToast={this.handleCloseCustomToast}
          title={this.state.toastMessage}
          warning
        />
        {resendOtpLoading ? <LoadingOverlay loading={true} /> : false}
        {registrationOTPVerifyLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
        {getAuthTokenLoading ? <LoadingOverlay loading={true} /> : false}
        {promptMobilePhoneInputLoading ? <LoadingOverlay loading={true} /> : false}
        {registrationOtpResendLoading ? <LoadingOverlay loading={true} /> : false}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  headerTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("xxlarge"),
    textAlign: "left",
    color: "black",
  },
  labelTextInputTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("large"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 40,
  },
  inputContainer: {
    marginTop: 40,
  },
  buttonStyle: {
    width: 120,
    marginTop: 30,
  },
});

function mapStateToProps(state) {
  return {
    resendOtpData: selector.resendOtpData(state),
    resendOtpLoading: selector.resendOtpLoading(state),
    resendOtpStatus: selector.resendOtpStatus(state),
    registrationOTPVerifyData: selector.registrationOTPVerifyData(state),
    registrationOTPVerifyLoading: selector.registrationOTPVerifyLoading(state),
    registrationOTPVerifyStatus: selector.registrationOTPVerifyStatus(state),
    getAuthTokenLoading: selector.getAuthTokenLoading(state),
    getAuthTokenData: selector.getAuthTokenData(state),
    getAuthTokenStatus: selector.getAuthTokenStatus(state),
    promptMobilePhoneInputData: selector.promptMobilePhoneInputData(state),
    promptMobilePhoneInputLoading: selector.promptMobilePhoneInputLoading(
      state
    ),
    promptMobilePhoneInputStatus: selector.promptMobilePhoneInputStatus(state),
    registrationOtpResendData: selector.registrationOtpResendData(state),
    registrationOtpResendLoading: selector.registrationOtpResendLoading(
      state
    ),
    registrationOtpResendStatus: selector.registrationOtpResendStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    registrationOtpVerify: (
      nric,
      otpReference,
      c2facode,
      mobileNo,
      mobileCountryCode
    ) =>
      dispatch(
        registrationAction.registrationOtpVerify(
          nric,
          otpReference,
          c2facode,
          mobileNo,
          mobileCountryCode
        )
      ),
    registrationOtpResend: (nric) =>
      dispatch(registrationAction.registrationOtpResend(nric)),
    getAuthTokenRequest: (nric) =>
      dispatch(authAction.getAuthTokenRequest(nric)),
    promptMobilePhoneInput: (nric, mobileNo, mobileCountryCode,recaptchaToken) =>
      dispatch(
        registrationAction.promptMobilePhoneInput(
          nric,
          mobileNo,
          mobileCountryCode,
          recaptchaToken
        )
      ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(RegistrationOtp)));
